export const homePageFr =  {
  "Utilisateurs": "Utilisateurs",
  "Roles": "Roles",
  "Depenses": "Depenses",
  "Produits": "Produits",
  "Mode de paiements": "Mode de paiements",
  "Mode de paiement": "Mode de paiement",
  "Permissions": "Permissions",
  "Atlas Softwares": "Atlas Softwares",
  "Statistiques": "Statistiques",
  "Fournisseurs": "Fournisseurs",
  "Achats": "Achats",
  "Clients": "Clients",
  "Ventes": "Ventes",
  "Consommations": "Consommations",

  "Service": "Service",
  "Vous n'etes pas autoriser a acceder a cette page": "Vous n'etes pas autoriser a acceder a cette page",

  "Chercher": "Chercher",
  "Choisissez un tableau" : "Choisissez un tableau",


}

